(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-product-recommendations"] && !Shopify.designMode) return;
  try {
    
(function () {
  const sections = document.querySelectorAll('.kr-recs');
  if (!sections.length) return;

  sections.forEach(sec => {
    sec.addEventListener('click', function (e) {
      const pill = e.target.closest('.kr-card__vpill');
      if (!pill || pill.classList.contains('is-sold')) return;

      const card = pill.closest('.kr-card');

      card.querySelectorAll('.kr-card__vpill').forEach(p => {
        p.classList.remove('is-active');
        p.setAttribute('aria-pressed', 'false');
      });

      pill.classList.add('is-active');
      pill.setAttribute('aria-pressed', 'true');

      const atc = card.querySelector('.kr-card__atc');
      if (atc && pill.dataset.vid) atc.dataset.vid = pill.dataset.vid;

      const priceEl = card.querySelector('.kr-card__price:not(.kr-card__price--was)');
      if (priceEl && pill.dataset.price) priceEl.textContent = pill.dataset.price;
    });

    sec.addEventListener('click', async function (e) {
      const btn = e.target.closest('.kr-card__atc:not(.kr-card__atc--out)');
      if (!btn || !btn.dataset.vid) return;

      btn.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            id: btn.dataset.vid,
            quantity: 1
          })
        });

        if (!res.ok) throw new Error('Cart Error');

        btn.classList.add('is-added');

        const lbl = btn.querySelector('.kr-card__atc-label');
        const orig = lbl.textContent;

        lbl.textContent = '✓ Added';

        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));

        setTimeout(() => {
          btn.classList.remove('is-added');
          lbl.textContent = orig;
          btn.disabled = false;
        }, 2000);

      } catch (err) {
        console.error('Failed to add to cart:', err);
        btn.disabled = false;
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
